/* eslint-disable spire/avoid-dynamic-translate */
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import resetReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ResetReCaptcha";
import validateReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ValidateReCaptcha";
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import { BrandCategoriesStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomReCaptcha from "@tCooneyBrothers/Components/CustomCaptcha";
import addCustomBrandFormFormFields from "@tCooneyBrothers/Handlers/CustomBrandFormHandler";
import loadUserDetails from "@tCooneyBrothers/Handlers/LoadUserDetails";
import CustomApplicationState from "@tCooneyBrothers/Store/CustomApplicationState";
import React, { FC, useContext, useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface Props extends WidgetProps {}
export interface BrandDetailsFormStyles {
    textArea?: TextAreaProps;
    flexStart?: InjectableCss;
    inputStyle?: InjectableCss;
    leftPadding?: InjectableCss;
    mainGridItem?: GridItemProps;
    halfGridItem?: GridItemProps;
    submitGridItem?: GridItemProps;
    sectionHeading?: InjectableCss;
    brandDetailForm?: InjectableCss;
    brandFormTitle?: TypographyProps;
    mainGridContainer?: GridContainerProps;
    submitButton?: ButtonPresentationProps;
    emailTextField?: TextFieldPresentationProps;
    textField?: TextFieldPresentationProps;
    commentTextField?: TextAreaProps;
    spinner?: LoadingSpinnerProps;
    spinnerWrapper?: InjectableCss;
    successModal?: ModalPresentationProps;
    modalContainer?: GridContainerProps;
    messageTextGridItem?: GridItemProps;
    messageText?: TypographyPresentationProps;
    message?: TypographyPresentationProps;
    successMsgImage?: InjectableCss;
    buttonGridItem?: GridItemProps;
    continueButton?: ButtonPresentationProps;
    recaptchWrapper?: InjectableCss;
}

export const formStyles: BrandDetailsFormStyles = {
    mainGridContainer: {
        gap: 0,
        css: css`
            display: flex;
            width: 100%;
            flex-wrap: wrap;
            flex-direction: row;
            align-items: flex-start;
            justify-content: center;
            margin: 0px;
        `,
    },
    successModal: {
        sizeVariant: "small",
    },
    messageTextGridItem: { width: 12 },
    messageText: {
        css: css`
            display: flex;
            align-items: flex-start;
        `,
    },
    successMsgImage: {
        css: css`
            background: url(/UserFiles/Images/Icons/checkedmark.png) no-repeat 0 0;
            padding: 7px 0 20px 30px;
            color: #193066;
            font-size: 13px;
            font-weight: bold;
            // margin-top: 15px;
            background-size: 24px;
        `,
    },
    message: {
        css: css`
            padding-left: 8px;
        `,
    },
    buttonGridItem: {
        width: 12,
        css: css`
            justify-content: flex-end;
        `,
    },
    brandDetailForm: {
        css: css`
            background: #ffffff;
            padding: 10px;
            border: #e1e1e1 1px solid;
            margin: 20px;
            [class^="GridOffset"] {
                width: 100%;
            }
        `,
    },
    leftPadding: {
        css: css``,
    },
    mainGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            display: block;
            padding: 0;
            margin-bottom: 20px !important;
        `,
    },
    sectionHeading: {
        css: css`
            font-style: italic;
            border-bottom: 2px solid #474747;
            padding: 9px 0px;
            width: 100%;
            margin-bottom: 20px;
            text-align: center;
        `,
    },
    brandFormTitle: {
        css: css`
            font-size: 20px;
            font-weight: bold;
            line-height: 1;
            text-align: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 0px 10px;
                            font-size: 14px;
                        `,
                        css`
                            padding: 0px 10px;
                            font-size: 14px;
                        `,
                        css`
                            padding: 0px 10px;
                            font-size: 14px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    halfGridItem: {
        width: [12, 12, 12, 12, 12],
    },
    submitGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            display: flex;
            justify-content: center;
            width: 100%;
        `,
    },
    inputStyle: {
        css: css`
            width: 100%;

            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }

            > div[class^="FormFieldStyle"] {
                position: relative;
                width: 100%;
                > label {
                    font-size: 13px;
                    position: absolute;
                    z-index: 1;
                    padding-left: 5px;
                    background-color: #fff;
                    display: inline-block;
                    width: auto;
                    left: 20px;
                }
                > div input[type="text"] {
                    font-size: 13px;
                }
                > div select {
                    font-size: 13px;
                }
                > div[class^="FormInputWrapper"] {
                    > input {
                        font-size: 13px;
                    }
                    > div {
                        > span {
                            font-size: 13px;
                        }
                    }
                }
                > div textarea {
                    &::placeholder {
                        /* Chrome, Firefox, Opera, Safari 10.1+ */
                        color: #999;
                        font-style: italic;
                        font-size: 12px;
                    }
            }
            > div[class^="TooltipWrapper"] {
                width: 10%;
                padding: 10px;
            }
        `,
    },
    commentTextField: {
        css: css`
            input {
                height: 180px;
            }
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    spinnerWrapper: {
        css: css`
            margin: 30px auto;
        `,
    },
    recaptchWrapper: {
        css: css`
            margin: 0 auto;
        `
    }
};

const styles = formStyles;

const StyledSpan = getStyledWrapper("span");
const StyledForm = getStyledWrapper("form");
const mapStateToProps = (state: CustomApplicationState) => {
    return {
        context: state.context,
        isAuthenticated: state.context?.session.isAuthenticated,
        signedInCompany: state.cbData.userDetails.value,
    };
};
const mapDispatchToProps = {
    addCustomBrandFormFormFields,
    resetReCaptcha,
    validateReCaptcha: makeHandlerChainAwaitable<{ location: string; recaptchaRef: React.RefObject<ReCAPTCHA | null> }, boolean>(
        validateReCaptcha,
    ),
    loadUserDetails
};

type OwnProps = Props & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;
const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

const BrandDetailsForm: FC<OwnProps> = props => {
    const [isFormLoading, setIsFormLoading] = useState(false);
    const { value: brand } = useContext(BrandStateContext);
    const { isLoading, value: brandCategories } = useContext(BrandCategoriesStateContext);
    const nameErrorMsg = siteMessage("brandForm_NameRequired");
    const emailRequiredFieldMessage = siteMessage("brandForm_Email_Required");
    const emailFieldMessage = siteMessage("brandForm_EmailAddress_ValidEmail");
    const [name, setName] = useState("");
    const [company, setCompany] = useState("");
    const [comment, setComment] = useState("");
    const [nameError, setNameError] = useState(nameErrorMsg);
    const [email, setEmail] = React.useState("");
    const [emailError, setEmailError] = useState(emailRequiredFieldMessage);
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const recaptchaRef: React.RefObject<ReCAPTCHA | null> = React.createRef();
    const validateName = (name: string) => {
        const errorMessage = !name.trim() ? nameErrorMsg : "";
        setNameError(errorMessage);
        return !errorMessage;
    };

    const validateEmail = (email: string) => {
        const errorMessage = !email ? emailRequiredFieldMessage : emailRegexp.test(email) ? "" : emailFieldMessage;
        setEmailError(errorMessage);
        return !errorMessage;
    };

    useEffect(() => {
        if(props.isAuthenticated) {
            if(props.context.session?.firstName !== "" || props.context.session?.lastName !== "") {
                setName(`${props.context.session?.firstName ?? ""} ${props.context.session?.lastName ?? ""}`);
                validateName(`${props.context.session?.firstName ?? ""} ${props.context.session?.lastName ?? ""}`);
            }
            if(props.context.session?.email !== "") {
                setEmail(props.context.session?.email ?? "");
                validateEmail(props.context.session?.email ?? "");
            }
            if(props.signedInCompany && props.signedInCompany.length > 0) {
                setCompany(props.signedInCompany[0].companyName);
            }
        }
    }, [props.context, props.signedInCompany]);

    useEffect(() => {
        validateName(name);
        validateEmail(email);
    }, [name, email]);

    useEffect(() => {
        if (props.isAuthenticated) {
            props.loadUserDetails();
        }
    }, []);

    if (!brand) {
        return null;
    }
    if (brand?.properties?.showContactForm !== "true") {
        return null;
    }

    
    const emailChangeHandler = (input: HTMLInputElement) => {
        validateEmail(input.value);
        setEmail(input.value);
    };

    const nameHandler = (input: HTMLInputElement) => {
        validateName(input.value);
        setName(input.value);
    };
    
    const setFields = () => {
        if(props.isAuthenticated) {
            setName(`${props.context.session?.firstName ?? ""} ${props.context.session?.lastName ?? ""}`);
            validateName(`${props.context.session?.firstName ?? ""} ${props.context.session?.lastName ?? ""}`);
            
            setEmail(props.context.session?.email ?? "");
            validateEmail(props.context.session?.email ?? "");
            if(props.signedInCompany && props.signedInCompany.length > 0) {
                setCompany(props.signedInCompany[0].companyName);
            }
        }
    }
    
    const companyHandler = (value: string) => {
        setCompany(value);
    };
    const commentHandler = (input: HTMLTextAreaElement) => {
        setComment(input.value);
    };

    const validateSubmitEnabled = () => {
        return !(emailError || nameError);
    };

    const resetFields = () => {
        setName("");
        setEmail("");
        setCompany("");
        setComment("");
        setIsSubmitted(false);
    };
    const submitHandler = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        if (!isSubmitted) {
            setIsSubmitted(true);
        }

        if (!validateSubmitEnabled()) {
            return false;
        }
        const isReCaptchaValid = await props.validateReCaptcha({ location: "brands", recaptchaRef });
        if (!isReCaptchaValid) {
            return;
        }
        setIsFormLoading(true);
        props.addCustomBrandFormFormFields({
            firstName: name,
            emailAddress: email,
            company,
            comments: comment,
            type: "ContactUsForBrand",
            URL: document.URL,
            onSuccess: () => {
                setIsFormLoading(false);
                resetFields();
            },
            onError: () => {
                setIsFormLoading(false);
            },
        });
        setIsModalOpen(true);
    };

    const continueButtonClickHandler = () => {
        setIsModalOpen(false);
        resetFields();
        setFields();
    };

    const modalCloseHandler = () => {
        setIsModalOpen(false);
        resetFields();
        setFields();
    };
    return (
        <StyledForm id="brandDetailForm" noValidate={true}>
            <StyledWrapper {...styles.brandDetailForm} className="Form-n">
                <form autoComplete="off">
                    <GridContainer className="GridContainer-n" {...styles.mainGridContainer} {...styles.leftPadding}>
                        {isLoading ? (
                            <LoadingSpinner {...styles.spinner} />
                        ) : !brandCategories || brandCategories.length === 0 ? (
                            <Typography
                                {...styles.brandFormTitle}
                                as="p"
                            >{`Contact Cooney Brothers, an authorized ${brand.name} distributor, for a quote`}</Typography>
                        ) : (
                            <Typography
                                {...styles.brandFormTitle}
                                as="p"
                            >{`Can’t find the ${brand.name} product you’re looking for?`}</Typography>
                        )}

                        <GridItem className="GridItem-n" {...styles.mainGridItem}>
                            <StyledWrapper {...styles.sectionHeading}>
                                {translate("Call or Text: (610) 272-2100 or fill out the form below.")}
                            </StyledWrapper>
                            <GridContainer>
                                {isFormLoading ? (
                                    <GridItem {...styles.halfGridItem}>
                                        <StyledWrapper {...styles.spinnerWrapper}>
                                            <LoadingSpinner {...styles.spinner} />
                                        </StyledWrapper>
                                    </GridItem>
                                ) : (
                                    <>
                                        <GridItem {...styles.halfGridItem}>
                                            <StyledWrapper {...styles.inputStyle}>
                                                <TextField
                                                    {...styles.textField}
                                                    label={translate("Name")}
                                                    value={name}
                                                    data-test-selector="brandDetail-name"
                                                    onChange={e => nameHandler(e.currentTarget)}
                                                    error={isSubmitted && nameError}
                                                    name="name"
                                                    required
                                                />
                                            </StyledWrapper>
                                        </GridItem>
                                        <GridItem {...styles.halfGridItem}>
                                            <StyledWrapper {...styles.inputStyle}>
                                                <TextField
                                                    {...styles.emailTextField}
                                                    type="email"
                                                    label={translate("Email Address")}
                                                    onChange={e => emailChangeHandler(e.currentTarget)}
                                                    value={email}
                                                    data-test-selector="email"
                                                    required
                                                    error={isSubmitted && emailError}
                                                    name="email"
                                                />
                                            </StyledWrapper>
                                        </GridItem>
                                        <GridItem {...styles.halfGridItem}>
                                            <StyledWrapper {...styles.inputStyle}>
                                                <TextField
                                                    {...styles.textField}
                                                    label={translate("Company")}
                                                    value={company}
                                                    data-test-selector="brandDetail-company"
                                                    onChange={e => companyHandler(e.target.value)}
                                                    name="company"
                                                />
                                            </StyledWrapper>
                                        </GridItem>
                                        <GridItem {...styles.halfGridItem}>
                                            <StyledWrapper {...styles.inputStyle}>
                                                <TextArea
                                                    label={translate("Comments")}
                                                    value={comment}
                                                    placeholder="Please provide as much information as possible, including product number (or specifications if unknown), quantity, delivery date, etc."
                                                    onChange={e => commentHandler(e.target)}
                                                    data-test-selector="brandDetail-comment"
                                                    {...styles.commentTextField}
                                                />
                                            </StyledWrapper>
                                        </GridItem>
                                        <StyledWrapper {...styles.recaptchWrapper}>
                                            <CustomReCaptcha recaptchaRef={recaptchaRef} location="brands" />
                                        </StyledWrapper>
                                        <GridItem {...styles.submitGridItem}>
                                            <StyledWrapper {...styles.submitGridItem} {...styles.flexStart}>
                                                <Button
                                                    {...styles.submitButton}
                                                    onClick={submitHandler}
                                                    data-test-selector="brandDetail-form-submit"
                                                >
                                                    {translate("Submit")}
                                                </Button>
                                                <Modal
                                                    headline={translate("Thank You")}
                                                    contentLabel="Confirm"
                                                    {...styles.successModal}
                                                    isOpen={isModalOpen}
                                                    handleClose={modalCloseHandler}
                                                >
                                                    <GridContainer {...styles.modalContainer}>
                                                        <GridItem {...styles.messageTextGridItem}>
                                                            <Typography {...styles.messageText}>
                                                                <StyledSpan {...styles.successMsgImage}></StyledSpan>
                                                                <StyledSpan {...styles.message}>
                                                                    {translate(
                                                                        "Your request is being processed and we will be in contact with you shortly.",
                                                                    )}
                                                                </StyledSpan>
                                                            </Typography>
                                                        </GridItem>
                                                        <GridItem {...styles.buttonGridItem}>
                                                            <Button
                                                                {...styles.continueButton}
                                                                onClick={continueButtonClickHandler}
                                                            >
                                                                {translate("OK")}
                                                            </Button>
                                                        </GridItem>
                                                    </GridContainer>
                                                </Modal>
                                            </StyledWrapper>
                                        </GridItem>
                                    </>
                                )}
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                </form>
            </StyledWrapper>
        </StyledForm>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(BrandDetailsForm),
    definition: {
        group: "Brand Details",
        displayName: "Brand Form",
        allowedContexts: ["BrandDetailsPage"],
    },
};

export default widgetModule;
